/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ExtFieldPc.vue?vue&type=template&id=c91a7604&scoped=true&"
import script from "./ExtFieldPc.vue?vue&type=script&lang=js&"
export * from "./ExtFieldPc.vue?vue&type=script&lang=js&"
import style0 from "./ExtFieldPc.vue?vue&type=style&index=0&id=c91a7604&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91a7604",
  null
  
)

export default component.exports